import { Clickable, Col, Divider, Icon, Row, Text } from 'components';
import { useOutsideClick } from 'core';
import { theme } from 'lib';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  width: 216px;
  position: absolute;
  background-color: #fff;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);
  z-index: 1;
  top: 30px;
  right: 0;
`;

const Menu = ({ visible, close, handleLogoutVisible }) => {
  const containerRef = useRef(),
    { t } = useTranslation(),
    navigate = useNavigate();

  useOutsideClick(containerRef, () => visible && close());

  if (!visible) return null;

  function navigateTo(type) {
    close();

    navigate(`/${type}`);
  }

  return (
    <React.Fragment>
      <Container ref={containerRef}>
        <Col pad="12px 0">
          <Clickable onClick={() => navigateTo('profile')}>
            <Row noFlex ht="48px" center>
              <Icon dimensions="20" type="profileOutline" col={theme.GREY_60} marg="0 8px 0 16px" />

              <Text med>{t('common.profile')}</Text>
            </Row>
          </Clickable>

          <Clickable onClick={() => navigateTo('settings')}>
            <Row noFlex ht="48px" center>
              <Icon dimensions="20" type="settings" col={theme.GREY_60} marg="0 8px 0 16px" />

              <Text med>{t('common.settings')}</Text>
            </Row>
          </Clickable>

          {/*
            <Clickable>
              <Row noFlex ht='48px' center>
                <Icon
                  dimensions='20'
                  type='game'
                  col={theme.SECONDARY}
                  marg='0 8px 0 16px'
                />

                <Text med>{t('header.upgradePlan')}</Text>
              </Row>
            </Clickable>
          */}

          <Row noFlex marg="8px 0">
            <Col />

            <Col noFlex wid="172px">
              <Divider />
            </Col>
          </Row>

          <Clickable onClick={handleLogoutVisible}>
            <Row noFlex ht="48px" center>
              <Icon dimensions="18" type="logout" col={theme.GREY_60} marg="0 8px 0 16px" />

              <Text med>{t('common.logOut')}</Text>
            </Row>
          </Clickable>
        </Col>
      </Container>
    </React.Fragment>
  );
};

export default Menu;
